module.exports = __webpack_public_path__ + "static/media/stones.75696da1.svg";